// eslint-disable-next-line no-unused-vars
import http from '@/core/http'
import storage from '@/core/service/localStorage'
import cookies from '@/core/service/session'

const state = {
  token: null,
  user: {
    name: '',
    id: '',
    email: '',
    customerId: null,
    entityCustomerId: null,
    userEntityIds: [],
    userEntityPaths: [],
    userRegionEntities: [], 
    jsonFlags: {}, 
  }, 
  idRegiao: null 
}

const headerAuth = (userToken, password) => window.btoa(`${userToken}:${password}`)
const actions = {
  /* Authenticação */
  login ({commit}, payload) {
    let headers = { headers: { Authorization: 'Basic ' + headerAuth(payload.name, payload.password) } }
    const data = { lang: payload.lang || 'teste' }
    const firebaseToken = cookies.get('firebase-token')

    if (firebaseToken) data['firebaseToken'] = firebaseToken

    return http.post(`autenticacao/usuarios/auth`, data, headers).then((res) => {
      // commit('LOGIN_SUCCESS', res.data.auth)
      commit('LOGIN_SUCCESS', res.data)
      return Promise.resolve(res)
    })
  },

  loginUpdateRegiao (_, payload) {
    return http.post(`autenticacao/usuarios/updated-region`, {}, { headers: { idRegion: payload, moduloname: 'gestao'}}).then((res) => {
      return Promise.resolve(res)
    })
  },

  recoverPassword ({commit}, payload) {
    return http.post(`recover/sendEmailRecoverPasswordAfiliados`, payload).then((res) => {
      commit('SEND_EMAIL_SUCCESS', res.data.message)
      return Promise.resolve(res)
    })
  },

  async getUser ({commit}) {
    let user = storage.get('auth-token')
    const result = await http.post('/autenticacao/roles/show', { id: user.roleId }, {headers: { moduloname: 'gestao'}})
    user = Object.assign(user, { role: result.data.name })    
    if (user) commit('SET_USER', user)
  },

  async setValueRegiao ({commit}, payload) {
    commit('SET_VALUE_REGIAON', payload)
  },

  clearUser ( { commit } ) {
    commit('CLEAR_USER')
  }
}

const mutations = {
  'LOGIN_SUCCESS' (state, e) {
    state.user = {
      name: e.name,
      id: e.id,
      email: e.email,
      userEntityIds: e.userEntityIds,
      userEntityPaths: e.userEntityPaths,
      responsibleEntity: e.responsibleEntity,
      customerId: e.customerId,
      entityCustomerId: e.entityCustomerId,
      userRegionEntities: e.userRegionEntities,
      jsonFlags: e.jsonFlags,
      jsonData: e.jsonData,
      contracts: e.contracts,
      typesContracts: e.typesContracts
    }
    storage.set('jwt', e.jwt)
    storage.set('auth-token', e)
  },
  'SEND_EMAIL_SUCCESS' (state, e) {
    state.username = e
  },
  'SET_USER' (state, e) {
    state.user = {
      name: e.name,
      id: e.id,
      email: e.email,
      customerId: e.customerId,
      entityCustomerId: e.entityCustomerId,
      role: e.role,
      userEntityIds: e.userEntityIds || [],
      userEntityPaths: e.userEntityPaths || [],
      jsonFlags: e.jsonFlags,
      jsonData: e.jsonData,
      userRegionEntities: e.userRegionEntities,
      contracts: e.contracts,
      typesContracts: e.typesContracts
    }
  },
  
  'CLEAR_USER' (state) {
    state.user = {
      name: '',
      id: '',
      email: '',
      userEntityIds: [],
      userEntityPaths: []
    }
  },
  'SET_VALUE_REGIAON' (state, payload) {
    console.log('change regiao')
    state.idRegiao = payload
  }
}

const getters = {
  user: state => state.user,
  getIdRegiao: state => state.idRegiao
}

export default { namespaced: true, state, actions, mutations, getters }